import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";
import "./blogDetail.css";

export default function BlogDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const ref = doc(db, "blogs", id);
        const snap = await getDoc(ref);

        if (snap.exists()) {
          setBlog(snap.data());
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchBlog();
  }, [id]);

  if (!blog) return <p style={{ padding: 40 }}>Loading blog...</p>;

  return (
    <section className="blog-detail">

      {/* BACK */}
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <div className="blog-detail-container">

        <img src={blog.img} alt={blog.title} />

        <span className="date">{blog.date}</span>

        <h1>{blog.title}</h1>

        <p className="blog-content">
          {blog.content}
        </p>

      </div>

    </section>
  );
}